// Shim that re-exports the CDN-loaded jQuery global as an ES module.
// This allows migrated files to `import $ from 'jquery'` without
// bundling a second copy of jQuery — they get the same instance
// that's already on window.jQuery from the CDN <script> tag.
export default window.jQuery;
export const jQuery = window.jQuery;
